import { Grid } from "@material-ui/core";
import GraphHeader from "features/landing/components/WorkorderDashboard/GraphHeader/GraphHeader";
import { GraphLoader } from "features/landing/components/WorkorderDashboard/GraphLoader";
import { workorderDashboardPageStyles } from "features/landing/components/WorkorderDashboard/WorkorderDashboardPageStyles";
import { useMemo } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const ActiveUsersGraphic = ({ users = [], loading, roles = [] }) => {
    const classes = workorderDashboardPageStyles();
    const RADIAN = Math.PI / 180;
    const graphColors = ['#F0857D', '#F8AA9E', '#FFCEBF', '#dab894', '#E9DEAA', '#FFD596', '#fdda90', '#D3E6BD', '#a2e1a2', '#A6F6E3', '#84DFC1', '#97DDE0', '#AADAFF', '#81d2f2', '#a0c4ff', '#b5d6d6 ', '#ceb5b7', '#cdb4db'];

    const graphValue = useMemo(() => {
        if (!users.length || !roles.length) return [];

        const filteredUsers = users.filter(user => user?.assignedRole?.length > 0);

        return roles.map(role => {
            const count = filteredUsers.filter(user =>
                user.assignedRole.some(x => x.roleId === role.key)
            ).length;

            return { name: role?.normalizedName, value: count };
        }).filter(val => val.value > 0);

    }, [users, roles]);

    const CustomTooltip = ({ payload }) => (
        <div className={classes.tooltip}>
            {payload?.[0]?.payload && (
                <p>
                    <b>{payload[0].payload.name} </b>
                    {payload[0].payload.value}
                </p>
            )}
        </div>
    );
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.75;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor='middle' dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    return (
        <Grid container direction="column" className={classes.graphWrapper} style={{ height: 350 }}>
            <Grid item>
                <GraphHeader title={'Active Users'} />
            </Grid>
            <Grid item style={{ height: 300 }}>
                <ResponsiveContainer width="90%" height="100%">
                    <PieChart>
                        <Pie
                            data={graphValue}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={80}
                            paddingAngle={0.5}
                        >
                            {graphValue.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={graphColors[index % graphColors.length]} />
                            ))}
                        </Pie>
                        <Legend
                            height={36}
                            iconType="circle"
                            layout="horizontal"
                            verticalAlign="bottom"
                            iconSize={10}
                            formatter={(value) => <span style={{ color: "#596579", fontWeight: 500 }}>{value}</span>}
                        />
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>
            </Grid>
            <GraphLoader loading={loading} />
        </Grid>
    );
};

export default ActiveUsersGraphic;
